import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fa-database',
      title: 'Data Engineering',
      description: 'Design and build robust, scalable data platforms that unify fragmented data into a single, trusted source of truth.',
      image: 'images/de.jpg',
      link: '/data-engineering'
    },
    {
      icon: 'fa-chart-line',
      title: 'Data Science',
      description: 'Turn data into actionable insight using advanced analytics, machine learning, and predictive modelling.',
      image: 'images/ds.jpg',
      link: '/data-science'
    },
    {
      icon: 'fa-robot',
      title: 'GenAI Solutions',
      description: 'Deploy enterprise-ready Agentic AI solutions tailored to your business context.',
      image: 'images/gen.jpg',
      link: '/genai'
    },
    {
      icon: 'fa-cogs',
      title: 'Automation',
      description: 'Streamline operations by automating repetitive and data-driven processes with AI decision engines.',
      image: 'images/auto.jpg',
      link: '/automation'
    }
  ];

  return (
    <section id="services" className="section">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>Comprehensive AI and data solutions for your business needs.</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="service-card"
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>
              <div className="service-content">
                <div className="service-icon">
                  <i className={`fas ${service.icon}`}></i>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
